/* eslint-disable react-hooks/exhaustive-deps */

import { Grid } from "@material-ui/core"
import { Modal, InputTextMaster, MasterButton } from "App/Component/ui"
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance3,
} from "App/constants"
import {
  convertToValidPrice,
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  isNull,
  titleModal,
} from "App/utils/helpers"
import React, { useContext, useEffect, useState } from "react"
import { getTotal, getTotalFilterID, hitungDiskon, isExist } from "../.."
import { numberToFixed } from "../.."
import { FormContext } from "../../../context/FormContext"
import { v4 as uuidv4 } from "uuid"
import { MSG_NOT_MINUS, itSelfEmpty } from "utils/all"
import PilihDokter from "../../SelectOption/PilihDokter"
import AlertDiskon from "../../AlertDiskon"

export const urlGetRikjangByKelas = "/penjualan/listRikjangByKelasId"

export const urlDelete = "/penjualan/deleteRikjang"
export const urlGet = "/penjualan/listRikjangByPenjualanId"

export const deleteRikjangById = async (formData) => {
  try {
    const res = await instance3.post(urlDelete, formData)

    if (res.data.status === 200) {
      return {
        state: true,
        message: res.data.message,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getRikjangByPenjualanID = async (id) => {
  try {
    const res = await instance3.get(`${urlGet}/${id}`)
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.data,
        message: res.data.message,
      }
    } else if (res.data.status === 204) {
      return {
        state: true,
        data: [],
        message: res.data.message,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const RESET_STATE_DAFTAR_RIKJANG = {
  id: "",
  mh_rikjang_id: "",
  rikjang_id: "",
  qty: "",
  keterangan: "",
  harga: "",
  hargaCustom: "",
  hargaCustom2: "",
  kelas_id: "",

  namaRikjang: "",

  doctor_id: null,
  doctor_name: "Pilih Dokter",
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "40px",
  },
  {
    id: "namaMsRikjang",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "harga_jual",
    disablePadding: false,
    label: "HARGA",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "namaJsRikjang",
    disablePadding: false,
    label: "JENIS",
    align: "left",
    minWidth: "100px",
  },
]

export const getAllRikjangByKelas = async (formFilter, pages, limit) => {
  try {
    const api = await instance3.post(`${urlGetRikjangByKelas}`, {
      kelasId: formFilter.kelas_id,
      asuransiId: formFilter.asuransi_id,
      namaMsRikjang: formFilter.name,
      id_gudang: itSelfEmpty(formFilter.id_gudang),
      halaman: pages,
      jumlah: limit,
    })
    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      }
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
      data: [],
      meta: {
        count: 0,
        pages: 1,
        limit: 10,
      },
    }
  }
}

export const ModalDaftarRikjang = ({
  setShowModal,
  formRikjang,
  setFormRikjang,
  setNewRikjangDijual,
  setNewDataRikjangByKelas,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT)

  const { formData, setFormData } = useContext(FormContext)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setDisabled(DISABLED_BUTTON_SUBMIT)
    try {
      if (isNull(formRikjang.qty)) {
        defaultToastError("Qty harus diisi")
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      } else {
        if (convertToValidPrice(formRikjang.qty) > 0) {
          if (isNull(formRikjang.doctor_id)) {
            defaultToastError("Dokter tidak boleh kosong")
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          } else {
            if (isNull(formRikjang.id)) {
              const checkExist = isExist(
                formData.rikjang,
                "mhRikjangId",
                formRikjang.mh_rikjang_id,
              )
              if (checkExist) {
                setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
                return defaultToastError("rikjang ini sudah ada di list")
              } else {
                await addRikjang()
              }
            } else {
              const filterRikjang = formData.rikjang.filter(
                (e) => e.id !== formRikjang.id,
              )
              const newSingleRikjang = setSingleRikjang("UPDATE")
              const newRikjang = [...filterRikjang, newSingleRikjang]
              if (!isNull(formData.penjualan_id)) {
                await addRikjangServer(
                  newSingleRikjang,
                  "/penjualan/updateRikjang",
                )
                setShowModal(false)
              } else {
                setNewRikjangDijual(newRikjang, false)
                setShowModal(false)
                defaultToastSuccess("Berhasil mengubah list rikjang")
              }
            }
          }
        } else {
          if (convertToValidPrice(formRikjang.qty) < 0) {
            defaultToastError(MSG_NOT_MINUS)
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          } else if (convertToValidPrice(formRikjang.qty) === 0) {
            defaultToastError("QTY tidak boleh 0")
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          } else if (isNull(formRikjang.hargaCustom)) {
            defaultToastError("Harga harus diisi")
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          } else {
            defaultToastError("Inputan tidak valid")
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          }
        }
      }
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      defaultToastError(error?.response?.data?.message)
    }
  }

  useEffect(() => {
    setFormRikjang({
      ...formRikjang,
      hargaCustom: convertToValidPrice(formRikjang.hargaCustom2),
    })
  }, [formRikjang.hargaCustom2])

  const setSingleRikjang = (type) => {
    const diskon = parseFloat(String(formRikjang.diskon).replace(",", ".")) || 0
    const { nilaiDiskon, totalHargaJual, totalHargaPokok } = hitungDiskon(
      formRikjang,
      "rikjang",
    )
    const qty = convertToValidPrice(formRikjang.qty)

    const singleRikjang = {
      mhRikjangId: formRikjang.mh_rikjang_id,
      qty: qty,
      keterangan: "",
      harga: formRikjang.harga,
      hargaCustom: formRikjang.hargaCustom,
      hargaCustom2: formRikjang.hargaCustom2,
      total: formRikjang.hargaCustom * qty,

      namaRikjang: formRikjang.namaRikjang,
      rikjang_id: formRikjang.rikjang_id,
      kelas_id: formData.kelas_id,
      asuransi_id: formData.asuransi_id,

      doctor_id: formRikjang.doctor_id,
      doctor_name: formRikjang.doctor_name,

      diskon,
      nilai_diskon: nilaiDiskon,
      total_harga_pokok: totalHargaPokok,
      total_harga_jual: totalHargaJual,
    }

    let newSingleRikjang
    if (type === "ADD") {
      newSingleRikjang = {
        id: uuidv4(),
        ...singleRikjang,
      }
    } else {
      newSingleRikjang = {
        id: formRikjang.id,
        ...singleRikjang,
      }
    }

    return newSingleRikjang
  }

  const addRikjang = async () => {
    const newSingleRikjang = setSingleRikjang("ADD")
    const newRikjang = [...formData.rikjang, newSingleRikjang]
    const reload = formData.reload_perhitungan || false

    if (!isNull(formData.penjualan_id)) {
      await addRikjangServer(newSingleRikjang, "/penjualan/addRikjang")
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      setShowModal(false)
    } else {
      await setFormData({
        ...formData,
        rikjang: newRikjang,
        reload_perhitungan: !reload,
      })
      defaultToastSuccess("Berhasil menambah rikjang")
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      setShowModal(false)
    }
    setNewRikjangDijual(newRikjang, false)
  }

  const addRikjangServer = async (rikjang, url) => {
    try {
      const totalRikjang = await getTotalFilterID(
        formData.rikjang,
        rikjang.id,
        "rikjang",
      )
      const hargaTotalRikjang =
        rikjang.qty * (rikjang.hargaCustom - rikjang.nilai_diskon) +
        totalRikjang

      const totalBarang = getTotal(formData.barang, "barang")
      const totalPaket = getTotal(formData.paket, "paket")
      const totalJasa = getTotal(formData.jasa, "jasa")
      const totalFasilitas = getTotal(formData.fasilitas, "fasilitas")

      const jumlah =
        totalBarang +
        hargaTotalRikjang +
        totalPaket +
        totalJasa +
        totalFasilitas

      const potongan = formData.potongan
      const subTotal = jumlah - potongan
      const taxPercent = isNull(formData.tax_percent) ? 0 : formData.tax_percent
      const taxNumber = (taxPercent / 100) * subTotal
      const total = subTotal + taxNumber

      const newRikjang = {
        ...rikjang,
        penjualanId: formData.penjualan_id,
        harga_total_rikjang: numberToFixed(
          convertToValidPrice(hargaTotalRikjang),
        ),
        total_Penjualan: numberToFixed(convertToValidPrice(jumlah)),
        sisa: numberToFixed(convertToValidPrice(total)),

        tax: taxPercent,
        jumlah_tax: numberToFixed(convertToValidPrice(taxNumber)),
        discount: numberToFixed(convertToValidPrice(formData.potongan / total)),
        jumlah_set_discount: potongan,
        hargaCustom: numberToFixed(rikjang?.hargaCustom || 0),
        nilai_diskon: numberToFixed(rikjang?.nilai_diskon || 0),
        total_harga_jual:
          numberToFixed(rikjang?.hargaCustom || 0) -
          numberToFixed(rikjang?.nilai_diskon || 0),
      }
      const res = await instance3.post(url, newRikjang)
      if (res.data.status === 200) {
        defaultToastSuccess(res.data.message)
        await setNewRikjangDijual(newRikjang, false)
        setNewDataRikjangByKelas()
      } else {
        defaultToastError(res.data.message)
      }
    } catch (error) {
      defaultToastError(error?.response?.data?.message)
    }
  }

  return (
    <Modal title={`${titleModal(formRikjang.id)} Rikjang`} show={setShowModal}>
      <form action="POST" onSubmit={(e) => handleSubmit(e)}>
        {formRikjang.id && (
          <AlertDiskon defaultDiskon={formData.diskon?.diskon_rikjang ?? 0} />
        )}
        <p className="mt-1 mb-1">{formRikjang.namaRikjang}</p>
        <Grid container spacing={1}>
          <InputTextMaster
            type="hidden"
            name="id"
            id="id"
            readOnly={true}
            value={formRikjang.id}
          />
          <Grid item sm={6}>
            <InputTextMaster
              name="qty"
              label="BANYAK"
              id="qty"
              value={formRikjang.qty}
              onChange={(e) => {
                let val = e.target.value
                if (!isNull(val)) {
                  setFormRikjang({
                    ...formRikjang,
                    qty: formatRupiah(val),
                  })
                } else {
                  setFormRikjang({
                    ...formRikjang,
                    qty: val,
                  })
                }
              }}
              placeholder="Banyak"
              autoFocus={true}
            />
          </Grid>

          <Grid item sm={6}>
            <InputTextMaster
              name="harga"
              label="HARGA"
              id="harga"
              placeholder="0"
              value={formRikjang.hargaCustom2}
              onInput={(e) => {
                let val = e.target.value
                if (!isNull(val)) {
                  setFormRikjang({
                    ...formRikjang,
                    hargaCustom2: formatRupiah(val),
                  })
                } else {
                  setFormRikjang({
                    ...formRikjang,
                    hargaCustom2: val,
                  })
                }
              }}
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name="discount-barang"
              label="DISKON (%)"
              id="discount-barang"
              value={formRikjang.diskon}
              onChange={(e) => {
                const raw = e.target.value
                if (raw === "") {
                  return setFormRikjang({ ...formRikjang, diskon: "" })
                }
                if (/^[0-9]*([.,][0-9]*)?$/.test(raw)) {
                  if (convertToValidPrice(raw) > 100) {
                    return setFormRikjang({ ...formRikjang, diskon: 100 })
                  } else {
                    return setFormRikjang({
                      ...formRikjang,
                      diskon: formatRupiah(raw),
                    })
                  }
                }
              }}
              placeholder="15"
              error={convertToValidPrice(formRikjang.diskon) > 100}
              message="Maksimal 100%"
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name="nilai-discount"
              label="NILAI DISKON"
              id="nilai-discount"
              value={formatRupiah(
                convertToValidPrice(
                  (convertToValidPrice(formRikjang.hargaCustom) *
                    (parseFloat(String(formRikjang.diskon).replace(",", ".")) ||
                      0)) /
                    100,
                ),
              )}
              disabled
              placeholder="Nilai Diskon"
            />
          </Grid>
          <Grid item sm={12}>
            <PilihDokter formData={formRikjang} setFormData={setFormRikjang} />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="submit"
            color={disabled.color}
            name={disabled.label}
            size="md"
          />
        </Grid>
      </form>
    </Modal>
  )
}
